import { actions } from '../constants/catalog_delivery_info_light_box/action';
import Dispatcher from '../dispatcher';

export const show = (showFreeShipping) =>
    Dispatcher.handleCatalogDeliveryInfoLightBoxAction({ type: actions.SHOW, payload: showFreeShipping });

export const hide = () =>
    Dispatcher.handleCatalogDeliveryInfoLightBoxAction({ type: actions.HIDE });
